module.exports = __webpack_public_path__ + "assets/4edd94a87e7ea1e17e41b157872aa3ca.mp3";